const KEY_TIMER = "@RC:limit";

export const renderMessageAlert = (value, t, counter) => {
  if (value === "Access denied, contact your supervisor")
    return t("Access denied, contact your supervisor");

  if (value === "Maximum number of attempts reached")
    return t("You have reached the maximum request limit", {
      counter,
    });

  return t("Invalid Credentials");
};

const saveDateStorage = (value) => {
  localStorage.setItem(KEY_TIMER, JSON.stringify(value));
};

export const clearDateStorage = () => {
  localStorage.removeItem(KEY_TIMER);
};

const getDateStorage = () => {
  const dateStorage = JSON.parse(localStorage.getItem(KEY_TIMER));

  return dateStorage;
};

export const recoveryLimitExceeded = () => {
  return { saveDateStorage, getDateStorage };
};
